import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { ApplicationContext } from '../ApplicationContext';
import { jsx as _jsx } from "react/jsx-runtime";
export var Provider = /*#__PURE__*/function (_React$Component) {
  _inherits(Provider, _React$Component);
  var _super = _createSuper(Provider);
  function Provider() {
    _classCallCheck(this, Provider);
    return _super.apply(this, arguments);
  }
  _createClass(Provider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        context = _this$props.context,
        children = _this$props.children;
      var store = context.getStore();
      var applicationContext = context.getApplicationContext();
      return /*#__PURE__*/_jsx(ApplicationContext.Provider, {
        value: applicationContext,
        children: /*#__PURE__*/_jsx(ReduxProvider, {
          store: store,
          children: React.Children.only(children)
        })
      });
    }
  }]);
  return Provider;
}(React.Component);